import { useEffect, useState } from "react";
import {
  FormControlLabel,
  Grid,
  MenuItem,
  Select,
  Switch,
  TextField,
} from "../../../components";
import { useImportContext } from "../../../contexts/import.context";
import { InputErros, PermisoesHelper, value } from "../../../helpers";
import { AddLayout } from "../../../layouts";
import { TagsService, notification } from "../../../services";
import { responseErros, userLogs, voltar } from "../../../utils";
import tagsValidator from "./middlewares/tags.validator";
import "./tags.css";

const AtivadoComponent = ({ tag, setTag }) => {
  return (
    <FormControlLabel
      control={
        <Switch
          id={'status-action'}
          checked={tag?.ativado ? tag.ativado : false}
          onChange={() =>
            setTag((tag) => {
              return {
                ...tag,
                ativado: !tag?.ativado,
              };
            })
          }
          name="ativado"
          color="primary"
        />
      }
      label={tag?.ativado ? "Ativado" : "Desativado"}
    />
  );
};

const tagsHex = [
  "#F50007",
  "#0EF54B",
  "#1F6223",
  "#F56400",
  "#6C0084",
  "#84002D",
  "#4E5EF2",
  "#007584",
  "#000E84",
];

const AddTagsView = ({ match }) => {
  const { id } = match.params;
  const { initialCollapses } = useImportContext();
  const [tag, setTag] = useState({
    ativado: true,
    tipo: "PRODUTO",
    cor: tagsHex[Math.floor(Math.random() * tagsHex.length)],
  });
  const [loading, setLoading] = useState(false);
  const [userLog, setUserLog] = useState({});
  const [inputErro, setInputErro] = useState([]);
  const inputErros = new InputErros(inputErro, setInputErro);
  const tagsService = new TagsService();
  const permissoesHelper = new PermisoesHelper();

  useEffect(() => {
    if (!id) return;
    buscarTags();
  }, []);

  const buscarTags = async () => {
    setLoading(true);
    const result = await tagsService.getById(id);
    if (!result.isAxiosError) {
      setTag(result.data);
    } else {
      responseErros(result);
    }
    setLoading(false);
  };

  async function onClickLog() {
    if ("userCreatedLog" in userLog) return;
    const logs = await userLogs(tag);
    setUserLog(logs);
    setLoading(false);
  }

  function handleChangeColor(cor) {
    setTag({
      ...tag,
      cor,
    });
  }

  function handleInputChange(e) {
    setTag({
      ...tag,
      [e.target.name]: e.target.value,
    });
  }

  const handleSubmit = async (indiceSelecionado) => {
    setLoading(true);
    tagsValidator
      .validate(tag, { abortEarly: false })
      .then(async () => {
        if (id) {
          const response = await tagsService.atualizar(id, tag);
          setLoading(false);
          if (!response.isAxiosError) {
            buscarTags();
            notification.alteracaoSucesso();
            initialCollapses();
            voltar();
          } else responseErros(response);
        } else {
          const response = await tagsService.cadastrar(tag);
          setLoading(false);
          if (!response.isAxiosError) {
            notification.cadastroSucesso();
            if (indiceSelecionado === 0) {
              initialCollapses();
              voltar();
              return;
            }
          } else responseErros(response);
        }
      })
      .catch((err) => {
        setLoading(false);
        inputErros.set(err);
      });
  };

  return (
    <AddLayout
      id={id}
      title={tag?.id ? "Editar Tag" : "Cadastrar Tag"}
      onClickSalvar={handleSubmit}
      loading={loading}
      userLog={tag?.id ? userLog : null}
      onClickLog={onClickLog}
      showUpdate={permissoesHelper.temPermisao("meios-pagamento-editar")}
      actions={<AtivadoComponent tag={tag} setTag={setTag} />}
    >
      <Grid container spacing={2} className="h-100">
        <Grid item xs={3}>
          <Select
            id="tipo"
            name="tipo"
            label="Tipo"
            margin="normal"
            value={value.text(tag?.tipo)}
            onChange={(event) => handleInputChange(event)}
          >
            <MenuItem value={"PESSOA"}>Pessoa</MenuItem>
            <MenuItem value={"PRODUTO"}>Produto</MenuItem>
          </Select>
        </Grid>
        <Grid item xs={9}>
          <TextField
            id="descricao"
            name="descricao"
            label="Descrição"
            variant="outlined"
            margin="normal"
            value={tag?.descricao ? tag.descricao : ""}
            onChange={(e) => {
              handleInputChange(e);
            }}
            fullWidth
            required
            error={inputErros.get("descricao")}
          />
        </Grid>
        <Grid item xs={12} className="">
          <h4
            className="text-center font-weight-bold text-uppercase"
            style={{ fontWeight: 800 }}
          >
            Escolha uma cor
          </h4>
          <p className="text-center font-weight-bold">
            clique para selecione uma cor
          </p>
          <div className="w-100 d-flex justify-content-center flex-wrap">
            {tagsHex.map((cor, index) => (
              <div key={index} onClick={() => handleChangeColor(cor)}>
                <i
                  className="ph-fill ph-bookmark-simple tag-bookmark"
                  style={{
                    color: cor,
                    opacity: cor === tag.cor ? 1 : 0.2,
                    "-webkit-text-stroke": cor === tag.cor ? "3px black" : "",
                  }}
                />
              </div>
            ))}
          </div>
        </Grid>
      </Grid>
    </AddLayout>
  );
};

export default AddTagsView;
